import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip } from '@mui/material';

const GBLessonStatus = (): Record<number, React.ReactElement> => {
	const { t } = useTranslation();

	return {
		1: <Chip label={t('gradeBook.present')} color="success" sx={{ ml: '5px' }} />,
		2: <Chip label={t('gradeBook.absent')} color="error" sx={{ ml: '5px' }} />,
		3: <Chip label={t('gradeBook.online')} color="info" sx={{ ml: '5px' }} />,
		6: <Chip label={t('gradeBook.late', { time: 5 })} color="warning" sx={{ ml: '5px' }} />,
		7: <Chip label={t('gradeBook.late', { time: 10 })} color="warning" sx={{ ml: '5px' }} />,
		8: <Chip label={t('gradeBook.late', { time: 15 })} color="warning" sx={{ ml: '5px' }} />,
	};
};

export default GBLessonStatus;
